import { render, staticRenderFns } from "./UserReport.vue?vue&type=template&id=6925b810&scoped=true&"
import script from "./UserReport.vue?vue&type=script&lang=js&"
export * from "./UserReport.vue?vue&type=script&lang=js&"
import style0 from "./UserReport.vue?vue&type=style&index=0&id=6925b810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6925b810",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6925b810')) {
      api.createRecord('6925b810', component.options)
    } else {
      api.reload('6925b810', component.options)
    }
    module.hot.accept("./UserReport.vue?vue&type=template&id=6925b810&scoped=true&", function () {
      api.rerender('6925b810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/point/UserReport.vue"
export default component.exports